import { render, staticRenderFns } from "./QuizResultView.vue?vue&type=template&id=f1013c76"
import script from "./QuizResultView.vue?vue&type=script&lang=js"
export * from "./QuizResultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports